const FinanceInsights = () => {
    return (
        <div className="dashboard-card">
            <h2>Finance Insights</h2>

            <ul className="finance-insights">
                <li>📈 Revenue increased 18% compared to last month.</li>
                <li>💰 12 invoices are awaiting payment.</li>
                <li>🏆 Ahmedabad office generated the highest revenue.</li>
                <li>📊 GST services contribute 31% of total revenue.</li>
                <li>⚠️ 4 payments are overdue by more than 30 days.</li>
            </ul>
        </div>
    );
};

export default FinanceInsights;
